import VueScrollTo from "vue-scrollto";
import constants from "../../common/constants";
import useBeneficiaryService from "../../composables/useBeneficiaryService";

export default {
    vueinstance: null,
  
    configure(vueInstance) {
      this.vueInstance = vueInstance
    },

    /*  
    * get beneficiaries lazy loading
    */
    getBeneficiariesLazyLoading() {    
      var self = this.vueInstance
      if ( !self.lazyLoading && !self.maxSearchResultsReached) {                
        self.lazyLoading = true;
        let params_query = {
          query: self.searchText,
          pageindex: self.pageNumber,
          eventcampaignid: self.eventCampaignId,
          tags: [],
          pagesize : self.pageSize
        }

        if (self.tagIdsAsCsv) {
          let tags = self.tagIdsAsCsv.split(',')
          params_query.tags = [...new Set(tags)].join(',')
        }
        params_query = self.passParamsExternal(
          params_query
        )

        useBeneficiaryService()
          .searchWithParams(params_query)
          .then(function(response) {
              self.pageNumber = response.data.PageNumber + 1
              self.totalPages = response.data.TotalPages
              if (self.selectedCharity.beneficiaryId == 0)
                  self.beneficiaryList = response.data.Beneficiaries
          })
          .then(function() {
            self.lazyLoading = false
          })
      }
    },

    /*  
    * get beneficiaries
    */
    loadBeneficiaries(query) {        
      var self = this.vueInstance;           

      useBeneficiaryService()
        .searchWithParams(query)
        .then(function(response) {
          if (self.pagingSettings == constants.PAGING_SETTINGS.PAGED) 
            self.charityResults = []

          response.data.Beneficiaries.forEach(beneficiary => {
            if (!self.charityResults.find(x => x.BeneficiaryAccountId == beneficiary.BeneficiaryAccountId))
              self.charityResults.push(beneficiary)
          })
          self.totalPages = response.data.TotalPages

          if (self.pagingSettings == constants.PAGING_SETTINGS.PAGED) {
            VueScrollTo.scrollTo("#vue-gf-beneficiary-search", "100", {
              easing: "ease-in",
              offset: -60,
              force: true,
            });
          }
        })
        .then(function() {
          self.lazyLoading = false
          self.valueEnterSearch = false
          self.configureLoadingCharitiesOnScroll()
          if (
            self.beneficiaryId > 0 &&
            !self.stagedPreselectedBeneficiary &&
            self.charityResults.length > 0
          ) {
            self.$_charityManagementMixin_stageCharity(self.charityResults[0])
            self.stagedPreselectedBeneficiary = true
          }
        })

      self.pageNumber = (self.pagingSettings != constants.PAGING_SETTINGS.PAGED) 
        ? self.pageNumber + 1
        : query.pageindex
    },


    /*
    * get beneficiaries for tier
    */
    loadBeneficiariesForTiers(query, maxResultsToDisplay) {
      var self = this.vueInstance              
      
      var loadedItems = 0
      useBeneficiaryService()
        .getbeneficiaryForTiers(query, maxResultsToDisplay)
        .then(response => {
          if (response.status === 200 && response.data.ResultsReturned > 0) {
            response.data.Beneficiaries.forEach(beneficiary => {
              if (
                !self.charityResults.find(x => x.BeneficiaryAccountId == beneficiary.BeneficiaryAccountId)
                && loadedItems < maxResultsToDisplay
              ) {
                self.charityResults.push(beneficiary)
                loadedItems++
              }
            })
          }
        })
        .then(function(){
          self.lazyLoading = false
          self.valueEnterSearch = false
          self.configureLoadingCharitiesOnScroll()
          if (
            self.beneficiaryId > 0 &&
            !self.stagedPreselectedBeneficiary &&
            self.charityResults.length > 0
          ) {
            self.$_charityManagementMixin_stageCharity(self.charityResults[0])
            self.stagedPreselectedBeneficiary = true
          }
      })
    },

    /*
    * perform search for beneficiaries
    */
    performSearchForBeneficiaries(query, region, eventCampaignId, pageSize, tagIdsAsCsv) {       
      var vm = this.vueInstance
      
      vm.pageNumber = 1

      if (query != "") {
        vm.loadingSearch = true
        vm.valueEnterSearch = true
      } else {
        vm.loadingSearch = false
        vm.valueEnterSearch = false
      }

      let params_query = {
        query: query,
        region: region,
        eventcampaignid: eventCampaignId,
        tags: [],
        pagesize : pageSize
      }

      if (tagIdsAsCsv) {
        let tags = tagIdsAsCsv.split(',')
        params_query.tags = [...new Set(tags)].join(',')
      }

      useBeneficiaryService()
        .searchWithParams(params_query)
        .then(function(response) {
          if (vm.selectedCharity.beneficiaryId == 0)
              vm.charityResults = response.data.Beneficiaries
          vm.totalPages = response.data.TotalPages
        })
        .then(function() {
          vm.loadingSearch = false
        })
      
      if (vm.pagingSettings != constants.PAGING_SETTINGS.PAGED) {
        vm.pageNumber = vm.pageNumber + 1
      }
    }
    
}